import { useBreakpoints as useVueUseBreakpoints } from '@vueuse/core';
import { computed } from 'vue';

const breakpoints = {
  mobilePortrait: 480,
  mobileLandscape: 768,
  tabletPortrait: 992,
  tabletLandscape: 1200,
};

export function useBreakpoints() {
  const vueUseBreakpoints = useVueUseBreakpoints(breakpoints);

  const isMobile = computed(() => vueUseBreakpoints.smaller('mobileLandscape').value);
  const isTablet = computed(
    () => vueUseBreakpoints.between('mobileLandscape', 'tabletPortrait').value
  );

  return {
    isMobile,
    isTablet,
  };
}
